import { Avatar, Space, Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useGetUserQuery } from '../../../../../../graphql/user.generated';
import getAvatarColor from '../../../../../shared/avatar/getAvatarColor';
import { DATAHUB_SYSTEM } from '../../../../../search/utils/constants';
import { useTranslation } from '../../../../../../i18n/useTranslation';

const AvatarStyled = styled(Avatar)<{ backgroundColor: string }>`
    color: #fff;
    background-color: ${(props) => props.backgroundColor};
`;

const UserAvatarColumn = ({ userUrn }: { userUrn: string }) => {
    const { t } = useTranslation();
    const { data } = useGetUserQuery({ variables: { urn: userUrn, groupsCount: 0 } });

    const fullName = data?.corpUser?.info?.fullName ?? t('System');
    const email = data?.corpUser?.username || '';

    const isSystemUser = email === DATAHUB_SYSTEM;

    const tooltipContent = (
        <div>
            <div>{fullName}</div>
            {!isSystemUser && <div>{email}</div>}
        </div>
    );

    return (
        <Tooltip title={tooltipContent}>
            <Space size="middle">
                <AvatarStyled size={25} backgroundColor={getAvatarColor(email || 'System')}>
                    {fullName?.[0] ?? 'S'}
                </AvatarStyled>
                <div>{fullName}</div>
            </Space>
        </Tooltip>
    );
};

export default UserAvatarColumn;
